/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'cookie-utils',
    'window'
],
function(
    cookieUtils,
    window
){

	function getDomain(){
		var host = window.location.host;
		var parts = host.split('.');
		var length = parts.length - 1;
		return '.' + parts[length-1] + '.' + parts[length];
	}

	return {
	    getDomain: getDomain,
		setCookie: function(name, cookieData){
			var now = new Date();
			var time = now.getTime();
			time += 3600 * 24 * 1000;
			now.setTime(time);
			//TODO: use cookieUtils to create the cookie
			window.document.cookie = name + '=' + JSON.stringify(cookieData) + '; expires=' + now.toUTCString() + '; domain=' + getDomain() + '; path=/';
		},
		hasCookie: function(name){
			return cookieUtils.readCookie(name);
		},
		getCookiePart: function(name, key){
			var obj = JSON.parse(cookieUtils.readCookie(name));
			return obj[key];
		},
		deleteCookie: function(name){
			//TODO: use cookieUtils to create the cookie
			window.document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + getDomain() + '; path=/';
		}

	}

});

}.call(window));